"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var core_1 = require("@material-ui/core");
var styles = {
    label: {
        "color": "#c5c8c8",
        "fontSize": "15px",
        "&$labelFocused": {
            color: "#949899"
        }
    },
    labelFocused: {},
    input: {
        "color": "#2a3133",
        "&:after": {
            borderBottomColor: "#c5c8c8"
        },
        "&:hover": {
            "&:before": {
                borderBottomColor: "#949899 !important"
            }
        },
        "&$inputFocused": {
            borderColor: "#949899"
        }
    },
    inputFocused: {}
};
function TextField(props) {
    var classes = props.classes, InputProps = props.InputProps, InputLabelProps = props.InputLabelProps, restProps = __rest(props, ["classes", "InputProps", "InputLabelProps"]);
    return (react_1.default.createElement(TextField_1.default, __assign({ InputLabelProps: __assign({ classes: {
                root: classes === null || classes === void 0 ? void 0 : classes.label,
                focused: classes === null || classes === void 0 ? void 0 : classes.labelFocused
            } }, InputLabelProps), InputProps: __assign({ classes: {
                root: classes === null || classes === void 0 ? void 0 : classes.input,
                focused: classes === null || classes === void 0 ? void 0 : classes.inputFocused
            } }, InputProps) }, restProps)));
}
exports.default = (0, core_1.withStyles)(styles)(TextField);
